<template>
    <section v-if="actions.length" aria-label="Azioni precedenti della NC" class="nc-previous-actions">
        <h3 class="t-title-3">Azioni precedenti</h3>
        <details v-for="action in actions" :key="action.id">
            <summary>{{ action.description }} · {{ action.status }}</summary>
            <dl>
                <dt>Tipologia originale</dt><dd>{{ action.type }}</dd>
                <dt>Responsabile</dt><dd>{{ action.owner || '—' }}</dd>
                <dt>Termine previsto</dt><dd>{{ date(action.due_date) || '—' }}</dd>
                <dt>Eseguita il</dt><dd>{{ date(action.done_at) || '—' }}</dd>
                <dt>Criterio di efficacia</dt><dd>{{ action.effectiveness_criterion || '—' }}</dd>
                <dt>Esito</dt><dd>{{ action.effectiveness_result || 'Da verificare' }}</dd>
                <dt>Evidenze</dt><dd>{{ action.effectiveness_note || '—' }}</dd>
                <dt>Verifica registrata da</dt><dd>{{ action.verified_by || '—' }}</dd>
            </dl>
            <v-btn v-if="canEdit(action)" text :disabled="disabled" @click="draft={...action}">Aggiorna azione precedente</v-btn>
        </details>
        <form v-if="draft" @submit.prevent="save">
            <v-select v-model="draft.status" :items="['aperta','in_corso','fatta','annullata']" label="Stato dell’azione precedente" outlined dense />
            <v-textarea v-model="draft.effectiveness_criterion" label="Criterio di efficacia dell’azione precedente" outlined dense rows="2" />
            <v-select v-model="draft.effectiveness_result" :items="[{text:'Da verificare',value:''},{text:'Efficace',value:'efficace'},{text:'Non efficace',value:'non_efficace'}]" label="Esito dell’azione precedente" outlined dense />
            <v-textarea v-model="draft.effectiveness_note" label="Evidenze della verifica precedente" outlined dense rows="2" />
            <p v-if="error" role="alert">{{ error }}</p>
            <v-btn text @click="draft=null">Annulla</v-btn><v-btn type="submit" color="primary" :disabled="disabled" :loading="busy">Salva azione precedente</v-btn>
        </form>
        <p v-if="disabled" class="mc-caption">Salva il piano prima di aggiornare le azioni precedenti.</p>
    </section>
</template>
<script>
import { API, date, errorMessage } from './ncInterne.mjs';
export default {
    name: 'NcInterneActions',
    props: { actions: {type: Array, default: () => []}, caseId: {type:String,required:true}, canWrite:Boolean, disabled:Boolean },
    data:()=>({draft:null,busy:false,error:''}),
    methods: {date,
        canEdit(action){return this.canWrite || action.owner===this.$store.getters.userdata?.username;},
        async save(){this.busy=true;this.error='';try{const response=await this.$work.post(`${API}casi/${this.caseId}/azioni/`,{id:this.draft.id,revision:this.draft.revision,status:this.draft.status,effectiveness_criterion:this.draft.effectiveness_criterion,effectiveness_result:this.draft.effectiveness_result,effectiveness_note:this.draft.effectiveness_note},true);this.$emit('updated',response.data);this.draft=null;this.$toast.success('Azione precedente aggiornata',{icon:'mdi-check-circle',timeout:3000});}catch(error){this.error=errorMessage(error);}finally{this.busy=false;}},
    },
};
</script>
<style scoped>
.nc-previous-actions { display: grid; gap: var(--space-3); margin-top: var(--space-4); overflow-wrap: anywhere; }
summary { cursor: pointer; padding: var(--space-2) 0; }
dl { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 2fr); gap: var(--space-2); }
dd { margin: 0; white-space: pre-wrap; }
</style>
